import { useState, useEffect } from 'react';
import type { ConfirmOptions } from '@admin-portal/host-contract';

type Pending = { opts: ConfirmOptions; resolve: (v: boolean) => void };
let pendingRef: { current: Pending | null } = { current: null };
const listeners = new Set<() => void>();

export function showConfirm(opts: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    pendingRef.current = { opts, resolve };
    listeners.forEach((l) => l());
  });
}

export function ConfirmModalRoot() {
  const [pending, setPending] = useState<Pending | null>(null);

  useEffect(() => {
    const sync = () => setPending(pendingRef.current);
    listeners.add(sync);
    return () => {
      listeners.delete(sync);
    };
  }, []);

  if (!pending) return null;

  const close = (result: boolean) => {
    pending.resolve(result);
    pendingRef.current = null;
    listeners.forEach((l) => l());
  };

  return (
    <div className="modal-backdrop" onClick={() => close(false)}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>{pending.opts.title}</h3>
        {pending.opts.body && <p>{pending.opts.body}</p>}
        <div className="modal-actions">
          <button onClick={() => close(false)}>Cancel</button>
          <button
            onClick={() => close(true)}
            className={pending.opts.danger ? 'danger' : 'primary'}
          >
            {pending.opts.danger ? 'Yes, do it' : 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
}
